.skeleton {
	position: relative;
}
